import { TopAirlinesByDomain } from '@/src/constants/topAirlines'
import { domainCountry } from '@/src/constants/domain';
import { getBrandName } from '../buildUtils';
import { TOP_AIRLINES } from '@/src/constants/topAirlines';

export const getTopAirlines = () => {
    const domain = domainCountry;
    return TopAirlinesByDomain[domain] || [];
}

export const getTopAirlinesForBrand = () => {
    const brandName = getBrandName() as 'flyin' | 'cleartrip';
    return TOP_AIRLINES[brandName] || []
}